module.exports = __webpack_public_path__ + "static/character-inject-83d643e411fbb4ce36bd59469b0f8668.svg";